<template>
    <el-dialog :visible="visible" width="800px" @close="handleClose" class="dialog" :close-on-click-modal="false">
        <div>
            <h2 style="text-align: center">关于中国成人白血病诊疗登记系统</h2>
            <h2 style="text-align: center">白血病登记病例随访工作的通知</h2>
            <div style="line-height: 30px;font-size: 15px">
                <div >{{hospital}}：</div>
                <div style="text-indent: 25px;">国家卫健委在2019年启动了全国成人白血病诊疗登记系统工作，感谢贵院对白血病登记系统工作的大力支持！</div>
                <div style="text-indent: 25px;">
                    在国家卫健委的领导下，在陈竺院士为顾问，陈赛娟院士牵头的专家委员会推进下，建立了国家级白血病信息化平台，形成了覆盖全国的白血病三级登记工作体系的白血病专病数据库，并探索建立了国家层面大数据驱动的多源数据库融合模式。
                    <span style="font-weight: bold">登记系统与多个国家级数据库开展合作，如国家癌症中心（NCC）的肿瘤登记数据库、国家疾病预防控制中心（CDC）的死因数据库，和医院质量监测系统（HQMS）的病案首页数据库，将白血病诊疗登记病例与各个国家级数据库进行链接，通过信息安全技术，尽可能多途径补充了全国白血病登记系统病例的后续诊疗随访信息，目前已形成了约10万白血病登记共享队列。</span>
                </div>
                <div style="text-indent: 25px;">这是国际上最大规模的白血病大数据库，来之不易。虽然应用国家级三大数据库进行对接和补充，但仍然有一部分病例未能随访到结局。为了解真实世界中国急性白血病患者的生存情况，提高各单位登记系统病例随访数据质量，经过专家委员会讨论，在全国范围内推进白血病登记数据共享信息和随访工作。白血病诊疗登记系统技术组把大数据融合链接到的随访信息反馈给贵单位，请贵单位进行核实，并欢迎充分利用，也希望对尚未随访的病例进行补充。</div>
                <div style="text-indent: 25px;">
                    截止目前，贵单位在成人白血病诊疗登记系统中，上报了2016年至今<span style="font-weight: bold">{{countCase}}</span>例登记病例，通过与NCC，CDC和HQMS 多个国家级数据库链接融合后，
                    采用大数据技术进一步补充了<span style="font-weight: bold">{{shareData.transplant || 0}}</span>
                    例登记病例的移植信息，<span style="font-weight: bold">{{shareData.follow||0}}</span>例登记病例的末次随访信息，<span style="font-weight: bold">{{shareData.death||0}}</span>例登记病例的死亡信息，
                    <span  style="font-weight: bold">截止末次随访时间在2023年12月31日，仍有{{dsfCount}}例登记病例亟待更新生存结局。</span>
                </div>
                <div style="text-indent: 25px;">
                    <span  style="font-weight: bold">我们诚挚邀请贵单位积极开展白血病登记系统随访工作，请贵单位在10月10日前完成本单位登记病例待随访工作</span>
                    。同时，为了更精准反映我国社会经济发展，白血病规范化治疗和靶向药物的应用促进白血病诊疗水平的发展趋势，我们将继续发挥成人急性白血病登记系统的优势，上报2021-2025年初发急性白血病病例，通过比较研究，展示我国白血病治疗的发展前景。
                </div>
                <div style="text-indent: 25px;">
                    白血病诊疗登记系统技术组，联系人：张佳楠 18868117307；巫慧怡 19811941296；联系邮箱：rmslinc@163.com。
                </div>
                <div style="text-align: right">全国成人白血病诊疗登记系统专家委员会
                </div>
                <div style="text-align: right">
                    2024年8月20日
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            visible: {
                default: false
            },
            shareData:{
                default: {}
            },
            hospital:{
                default: ""
            },
            countCase:{
                default:0
            },
            dsfCount:{
                default:0
            }
        },
        data() {
            return {
            }
        },
        methods: {
            handleClose() {
                this.$emit('close')
            },
        }
    }
</script>

<style scoped>
   ::v-deep .el-dialog__body{
       padding: 10px 20px;
   }
   ::v-deep .el-dialog {
       margin-top: 1vh !important;
   }
</style>
